import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// 15s timeout prevents "loading forever" UX when a request silently stalls
// (slow CDN, dropped connection, etc.). After timeout the catch path runs,
// letting components show empty/retry states instead of permanent skeletons.
export const api = axios.create({ baseURL: API, timeout: 15000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sw_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// One automatic retry for safe (GET) requests that fail due to a transient
// network error or timeout. Anything else propagates immediately.
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("sw_token");
      localStorage.removeItem("sw_user");
    }
    const cfg = err?.config;
    const isTimeoutOrNetwork = err?.code === "ECONNABORTED" || err?.message === "Network Error";
    const isGet = (cfg?.method || "get").toLowerCase() === "get";
    if (cfg && isGet && isTimeoutOrNetwork && !cfg.__retried) {
      cfg.__retried = true;
      return api.request(cfg);
    }
    return Promise.reject(err);
  }
);
